import {
  Typography,
  Card,
  Box,
  Divider,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { formatDateTime } from "../../../utils/paymentFormat";
import ApprovalActions from "./ApprovalActions";
import { ApprovalStatusBadge } from "./ApprovalStatusBadge";
import { ApproverField } from "./ApproverField";

function InfoApprovalTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("Approval")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Approval status and history of this transfer.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} pt={2.5} pb={1.5} display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
            <Typography variant="h5" fontWeight="bold">
              {t("Approval")}
            </Typography>
            <ApprovalActions />
          </Box>
          <Divider />
          <Box px={2} py={1}>
            <InfoRow label={t("Status")}>
              <ApprovalStatusBadge />
            </InfoRow>
            {record.approvedBy && (
              <>
                <InfoRow label={t("Approved by")}>
                  <ApproverField />
                </InfoRow>
                <InfoRow label={t("Approved at")}>{formatDateTime(record.approvedAt)}</InfoRow>
              </>
            )}
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoApprovalTab;
